module.exports = __webpack_public_path__ + "media/images/logo-dark-d68ee3e8.svg";